"use strict";

// window.dataLayer = window.dataLayer || [];
// function gtag() {
//   dataLayer.push(arguments);
// }
// gtag("js", new Date());

// gtag("config", "G-7W9FBH2XYR");

var callBackFormFields = [
  { id: "contact-name", name: "name", required: true },
  { id: "contact-email", name: "email", required: true },
  { id: "contact-phone", name: "phone", required: true },
  { id: "contact-time", name: "time", required: false },
  { id: "contact-message", name: "message", required: false },
];

window.showCallBackRequestForm = function showCallBackRequestForm() {
  const contactForm = document.querySelector("#call-back-popup");
  contactForm.classList.add("flex");

  contactForm.classList.remove("hidden");
};

window.hideCallBackRequestForm = function hideCallBackRequestForm() {
  const contactForm = document.querySelector("#call-back-popup");
  contactForm.classList.add("hidden");
  contactForm.classList.remove("flex");

  for (const field of callBackFormFields) {
    document.getElementById(field.id).value = "";
  }
};

window.showCallBackRequestSubmittedForm =
  function showCallBackRequestSubmittedForm() {
    const contactForm = document.querySelector(
      "#call-back-request-submitted-popup",
    );
    contactForm.classList.add("flex");

    contactForm.classList.remove("hidden");
  };

window.hideCallBackRequestSubmittedForm =
  function hideCallBackRequestSubmittedForm() {
    const contactForm = document.querySelector(
      "#call-back-request-submitted-popup",
    );
    contactForm.classList.add("hidden");
    contactForm.classList.remove("flex");
  };

window.requestChat = function requestChat() {
  const contactForm = document.querySelector("#call-back-popup");

  document.querySelector("#contact-name").value =
    document.querySelector("#request-chat-name").value;
  document.querySelector("#contact-phone").value = document.querySelector(
    "#request-chat-phone",
  ).value;

  showCallBackRequestForm();
};

window.submitContactForm = async function submitContactForm(event) {
  event.preventDefault();

  let requestData = {};
  let valid = true;

  for (const field of callBackFormFields) {
    const element = document.getElementById(field.id);

    if (field.required) {
      if (element.value.length === 0) {
        element.classList.add("invalid");
        valid = false;
      } else if (field.name === "email" && !element.validity.valid) {
        element.classList.add("invalid");
        valid = false;
      } else {
        element.classList.remove("invalid");
        requestData[field.name] = element.value;
      }
    } else {
      requestData[field.name] = element.value;
    }
  }

  if (valid) {
    grecaptcha.enterprise.ready(async () => {
      requestData["recaptcha"] = await grecaptcha.enterprise.execute(
        "6LdqGpIrAAAAAPdXmZUPd2CM7xydWRlyzlDFLVq1",
        { action: "CALL_BACK_REQUEST" },
      );

      await fetch("https://api.my-orders.co.uk/request_call_back", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      hideCallBackRequestForm();
      showCallBackRequestSubmittedForm();
    });
  }
};
